function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1925",
    style: {
      fill: "#5d236f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.435704,257.94907 c 0.93345,0 1.84503,0.091 2.729442,0.25964 3.1877,-8.17139 8.030988,-21.2418 8.030988,-25.2289 0,-5.94254 -4.817888,-10.75972 -10.76043,-10.75972 -5.942893,0 -10.75972,4.81718 -10.75972,10.75972 0,3.9871 4.842578,17.05751 8.030278,25.22891 0.884415,-0.16863 1.796347,-0.25965 2.729442,-0.25965"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1927",
    style: {
      fill: "#5d236f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.452512,256.09522 c 0.660049,-0.66004 1.369484,-1.24001 2.113847,-1.74589 -3.524605,-8.03311 -9.341909,-20.69889 -12.161309,-23.51864 -4.201584,-4.20229 -11.014428,-4.20229 -15.216364,3.5e-4 -4.202288,4.20229 -4.202288,11.01443 -3.53e-4,15.21672 2.819047,2.8194 15.485534,8.63741 23.517929,12.16096 0.50659,-0.74401 1.086557,-1.45345 1.74625,-2.1135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1929",
    style: {
      fill: "#5d236f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.446619,255.47927 c 0,-0.93309 0.09172,-1.84503 0.259643,-2.72909 -8.171743,-3.1877 -21.241807,-8.03063 -25.228548,-8.03063 -5.9425415,0 -10.7600745,4.81718 -10.7597225,10.75972 0,5.9429 4.817181,10.76008 10.7597225,10.76008 3.986741,0 17.056805,-4.84293 25.228548,-8.03063 -0.16792,-0.88442 -0.259643,-1.79635 -0.259643,-2.72945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1931",
    style: {
      fill: "#5d236f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.592771,256.46282 c -0.659694,-0.6597 -1.240012,-1.36949 -1.745896,-2.11349 -8.032398,3.52389 -20.699236,9.3412 -23.51793,12.1606 -4.2022895,4.20197 -4.2022895,11.01404 0,15.21707 4.201936,4.20162 11.014427,4.2019 15.217069,0 2.818695,-2.81947 8.636353,-15.48624 12.160248,-23.51828 -0.744008,-0.50659 -1.453091,-1.08621 -2.113491,-1.7459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1933",
    style: {
      fill: "#5d236f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.977175,258.46836 c -0.932746,2.6e-4 -1.845029,-0.0917 -2.729089,-0.25965 -3.188407,8.1714 -8.030634,21.24174 -8.030634,25.22884 0,5.94264 4.816827,10.75944 10.760427,10.75944 5.941838,0 10.759723,-4.8168 10.759723,-10.75944 0,-3.9871 -4.843285,-17.05744 -8.03134,-25.22883 -0.88406,0.16792 -1.795637,0.25964 -2.729087,0.25964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1935",
    style: {
      fill: "#5d236f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.960367,260.32221 c -0.659342,0.66004 -1.369483,1.24001 -2.113846,1.74589 3.52425,8.03311 9.341908,20.69889 12.160956,23.51793 4.202642,4.20303 11.014779,4.20303 15.217069,0 4.201583,-4.20162 4.20229,-11.01411 0,-15.21671 -2.8194,-2.81905 -15.485534,-8.63706 -23.518284,-12.1606 -0.505883,0.744 -1.08585,1.45344 -1.745895,2.11349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1937",
    style: {
      fill: "#5d236f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.966261,260.93816 c 2.64e-4,0.93274 -0.09137,1.84502 -0.259999,2.72908 8.171747,3.1877 21.242161,8.03064 25.22855,8.03064 5.943249,0 10.76043,-4.81718 10.76043,-10.76008 0,-5.94218 -4.817181,-10.76007 -10.76043,-10.76007 -3.986741,0 -17.056803,4.84329 -25.22855,8.03099 0.16863,0.88441 0.259999,1.79563 0.259999,2.72944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1939",
    style: {
      fill: "#5d236f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.820109,259.95461 c 0.659693,0.65934 1.23966,1.36948 1.74625,2.11349 8.031691,-3.52389 20.69888,-9.3412 23.517577,-12.1606 4.202641,-4.20194 4.202641,-11.01407 0,-15.21707 -4.201232,-4.20158 -11.014427,-4.20193 -15.217069,0 -2.818696,2.8194 -8.636355,15.48589 -12.160605,23.51829 0.744363,0.50623 1.453799,1.0862 2.113847,1.74589"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1941",
    style: {
      fill: "#a771bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.507671,251.95432 c -2.037996,-4.57483 -4.562121,-10.03512 -6.824485,-14.33266 1.275643,-1.84326 3.404658,-3.05082 5.815893,-3.05082 3.34363,0 6.144683,2.32128 6.879167,5.44019 -1.857021,3.38772 -3.965927,7.78474 -5.870575,11.94329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1943",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.539296,254.08545 c -2.207684,-4.95582 -5.281084,-11.48539 -7.019571,-13.56572 0.169334,-1.06398 0.575734,-2.04858 1.163461,-2.89807 2.262364,4.29754 4.786489,9.75783 6.824485,14.33266 -0.329846,0.71966 -0.653344,1.43227 -0.968375,2.13113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1945",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.546352,254.10062 c -0.0021,-0.005 -0.0046,-0.0102 -0.0071,-0.0152 0.315031,-0.69886 0.638529,-1.41147 0.968375,-2.13114 1.904648,-4.15854 4.013554,-8.55556 5.870575,-11.94329 0.123121,0.52211 0.188383,1.0668 0.188383,1.62666 0,0.11959 -0.0067,0.25153 -0.01976,0.39511 -0.29845,0.21661 -0.5842,0.45967 -0.853371,0.72884 -1.415696,1.41605 -3.982509,6.61282 -6.147152,11.33898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1947",
    style: {
      fill: "#a771bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.304552,251.82097 c -4.683831,-1.7974 -10.348383,-3.88126 -15.000463,-5.32483 -0.401109,-2.20521 0.250472,-4.56424 1.955447,-6.26957 1.380066,-1.38042 3.188405,-2.07045 4.99745,-2.07045 1.808339,0 3.617383,0.69039 4.997098,2.0701 0.08467,0.0847 0.173212,0.18274 0.265641,0.29351 -0.05786,0.36407 -0.08784,0.73766 -0.08784,1.11795 0,1.7071 1.351491,5.9496 2.872668,10.18329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1949",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 38.102536,254.0029 c -5.066949,-1.94416 -11.868856,-4.39244 -14.571839,-4.63444 -0.632531,-0.87207 -1.0414,-1.85562 -1.226608,-2.87232 4.65208,1.44357 10.316632,3.52743 15.000463,5.32483 0.262819,0.73201 0.530932,1.46367 0.797984,2.18193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1951",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.706262,258.20872 v 0 0 c -0.110066,-0.58068 -0.170391,-1.18005 -0.170391,-1.79247 -2.65e-4,-0.61277 0.06032,-1.21214 0.170391,-1.79246 -0.07549,-0.0296 -0.151693,-0.0593 -0.2286,-0.0893 0.04022,-0.60536 0.11783,-1.20085 0.2286,-1.78435 -0.761645,-0.29704 -1.566333,-0.60889 -2.40171,-0.92921 -1.521177,-4.23369 -2.872668,-8.47619 -2.872668,-10.18329 0,-0.38029 0.02998,-0.75388 0.08784,-1.11795 1.738487,2.08033 4.811887,8.6099 7.019571,13.56572 -0.654754,1.45274 -1.272821,2.84656 -1.833034,4.12326 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1953",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.477662,254.53453 c -0.439912,-0.17109 -0.899935,-0.34925 -1.375126,-0.53163 -0.267052,-0.71826 -0.535165,-1.44992 -0.797984,-2.18193 0.835377,0.32032 1.640065,0.63217 2.40171,0.92921 -0.11077,0.5835 -0.188383,1.17899 -0.2286,1.78435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1955",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.706262,258.20872 v 0 0 0 0 c 0.560213,-1.27671 1.17828,-2.67053 1.833034,-4.12327 0.0024,0.005 0.0049,0.0102 0.0071,0.0152 -0.66675,1.45521 -1.295048,2.86597 -1.84009,4.1081 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1957",
    style: {
      fill: "#a771bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 19.118858,262.23179 c -1.842911,-1.27529 -3.050469,-3.4043 -3.050469,-5.81519 -3.44e-4,-3.90383 3.163711,-7.06755 7.06755,-7.06755 0.119591,0 0.251177,0.006 0.394758,0.0194 0.216606,0.29845 0.459669,0.58384 0.728486,0.85266 1.207206,1.2072 5.162903,3.2512 9.231842,5.16925 -4.582231,2.04047 -10.062281,4.57306 -14.372167,6.84142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1959",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 22.017633,263.39561 c -1.063978,-0.16934 -2.048933,-0.57574 -2.898775,-1.16382 4.309886,-2.26836 9.789936,-4.80095 14.372167,-6.84142 0.703792,0.33161 1.410404,0.65935 2.107494,0.97861 -4.957585,2.20804 -11.498439,5.28637 -13.580886,7.02663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1961",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.706262,258.20872 v 0 c -0.488595,-0.33268 -0.954262,-0.71332 -1.388178,-1.14689 -0.433565,-0.43321 -0.814565,-0.89958 -1.14653,-1.38818 -0.07444,0.0328 -0.149225,0.0656 -0.224718,0.0988 -0.40005,-0.45649 -0.766234,-0.93239 -1.099961,-1.4231 -0.7493,0.32843 -1.537758,0.67662 -2.35585,1.04104 -4.068939,-1.91805 -8.024636,-3.96204 -9.231842,-5.16925 -0.268817,-0.26882 -0.51188,-0.55421 -0.728486,-0.85266 2.702983,0.242 9.50489,2.69028 14.571839,4.63444 0.557741,1.50036 1.110898,2.94217 1.603726,4.20582 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1963",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.598519,256.36898 c -0.69709,-0.31926 -1.403702,-0.647 -2.107494,-0.97861 0.818092,-0.36442 1.60655,-0.71261 2.35585,-1.04104 0.333727,0.49071 0.699911,0.96661 1.099961,1.4231 -0.432152,0.19015 -0.883357,0.38947 -1.348317,0.59655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1965",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.706262,258.20872 c -0.16792,-0.88442 -0.259643,-1.79635 -0.259643,-2.72945 0,-0.3175 0.01058,-0.63253 0.03104,-0.94474 0.07691,0.03 0.153107,0.0596 0.2286,0.0893 -0.110066,0.58032 -0.170743,1.17969 -0.170391,1.79246 0,0.61242 0.06032,1.21179 0.170391,1.79246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1967",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.706262,258.20872 c -0.492828,-1.26365 -1.045985,-2.70546 -1.603726,-4.20582 0.475191,0.18238 0.935214,0.36054 1.375126,0.53163 -0.02045,0.31221 -0.03104,0.62724 -0.03104,0.94474 0,0.9331 0.09172,1.84503 0.259643,2.72945 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1969",
    style: {
      fill: "#a771bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.721925,275.72547 c -1.808692,0 -3.617384,-0.68968 -4.99745,-2.06968 -2.760133,-2.76048 -2.760133,-7.23476 0,-9.99454 0.08431,-0.0847 0.182739,-0.17322 0.293158,-0.26564 0.364067,0.0579 0.737658,0.0878 1.118306,0.0878 1.706738,0 5.948891,-1.35149 10.182223,-2.87267 -1.797401,4.68312 -3.88126,10.34835 -5.324121,15.00004 -0.420511,0.0766 -0.846314,0.11465 -1.272116,0.11465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1971",
    style: {
      fill: "#a771bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 27.994041,275.61082 c 1.442861,-4.65169 3.52672,-10.31692 5.324121,-15.00004 0.732015,-0.26282 1.46403,-0.53093 2.182638,-0.79799 -1.943806,5.06625 -4.392083,11.86815 -4.634441,14.57117 -0.871715,0.63282 -1.855965,1.04165 -2.872318,1.22686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1973",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.135939,263.48345 c -0.380648,0 -0.754239,-0.03 -1.118306,-0.0878 2.082447,-1.74026 8.623301,-4.81859 13.580886,-7.02663 1.455208,0.6664 2.865967,1.29469 4.107743,1.83973 v 0 0 c -0.58067,0.11007 -1.178983,0.1704 -1.792462,0.1704 -0.0019,0 -0.0035,0 -0.0053,0 -0.611013,0 -1.207913,-0.0603 -1.787173,-0.1704 -0.02928,0.0755 -0.05891,0.1517 -0.0889,0.2286 -0.605719,-0.0399 -1.201209,-0.11782 -1.78435,-0.2286 -0.297392,0.762 -0.608894,1.56634 -0.929924,2.40207 -4.233332,1.52118 -8.475485,2.87267 -10.182223,2.87267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1975",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.318162,260.61078 c 0.32103,-0.83573 0.632532,-1.64007 0.929924,-2.40206 0.583141,0.11077 1.178631,0.18873 1.78435,0.22859 -0.17145,0.43992 -0.34925,0.89994 -0.531636,1.37548 -0.718608,0.26706 -1.450623,0.53517 -2.182638,0.79799 m 6.3881,-2.40207 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1977",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.706262,258.20872 c -0.744008,-0.50659 -1.453091,-1.08621 -2.113491,-1.7459 -0.224367,-0.22472 -0.439912,-0.45473 -0.645935,-0.69039 0.07549,-0.0332 0.150283,-0.066 0.224718,-0.0988 0.331965,0.4886 0.712965,0.95497 1.14653,1.38818 0.433916,0.43357 0.899583,0.81421 1.388178,1.14689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1979",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.706262,258.20872 c -1.241776,-0.54505 -2.652535,-1.17334 -4.107743,-1.83974 0.46496,-0.20708 0.916165,-0.4064 1.348317,-0.59655 0.206023,0.23566 0.421568,0.46567 0.645935,0.69039 0.6604,0.65969 1.369483,1.23931 2.113491,1.7459 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1981",
    style: {
      fill: "#a771bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.914152,281.84659 c -3.90384,0 -7.067198,-3.1641 -7.067198,-7.06685 0,-0.12005 0.0067,-0.25191 0.01939,-0.39578 0.29845,-0.21636 0.583846,-0.45942 0.853017,-0.72817 1.206852,-1.20727 3.250493,-5.16255 5.168545,-9.23148 2.040821,4.58258 4.573059,10.06192 6.841773,14.3717 -1.275643,1.84302 -3.404658,3.05058 -5.815541,3.05058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1983",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.729694,278.79601 c -2.268715,-4.30978 -4.800952,-9.78912 -6.841773,-14.3717 0.331613,-0.70379 0.659696,-1.41112 0.978958,-2.10785 2.208038,4.95758 5.286375,11.49907 7.02663,13.58127 -0.168982,1.06398 -0.575734,2.04848 -1.163815,2.89828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1985",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 30.866359,274.38396 c 0.242358,-2.70302 2.690635,-9.50492 4.634441,-14.57117 1.500362,-0.55774 2.942167,-1.11125 4.205462,-1.60407 v 0 0 c -0.331962,0.48859 -0.712962,0.95461 -1.146526,1.38817 -0.433211,0.43357 -0.899232,0.81422 -1.388182,1.14689 0.03246,0.0741 0.06562,0.14922 0.09878,0.22471 -0.456497,0.40005 -0.932747,0.76589 -1.423813,1.09961 0.32879,0.7493 0.676981,1.53812 1.0414,2.35621 -1.918052,4.06893 -3.961694,8.02421 -5.168546,9.23148 -0.269171,0.26875 -0.554566,0.51181 -0.853016,0.72817"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1987",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.887921,264.42431 c -0.364419,-0.81809 -0.71261,-1.60691 -1.0414,-2.35621 0.491066,-0.33372 0.967316,-0.69956 1.423813,-1.09961 0.189793,0.43216 0.389112,0.88301 0.596545,1.34797 -0.319262,0.69673 -0.647345,1.40406 -0.978958,2.10785 m 2.818341,-6.21559 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1989",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.972942,258.46836 c -0.31609,0 -0.629708,-0.0106 -0.940506,-0.031 0.02998,-0.0769 0.05962,-0.1531 0.0889,-0.2286 0.57926,0.11007 1.17616,0.1704 1.787173,0.1704 0.0019,0 0.0035,0 0.0053,0 0.613479,0 1.211792,-0.0603 1.792462,-0.1704 -0.88406,0.16793 -1.795637,0.25965 -2.729087,0.25965 -0.0013,0 -0.0028,0 -0.0042,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1991",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.5008,259.81279 c 0.182386,-0.47554 0.360186,-0.93556 0.531636,-1.37548 0.310798,0.0205 0.624416,0.031 0.940506,0.031 0.0013,0 0.0028,0 0.0042,0 0.93345,0 1.845027,-0.0917 2.729087,-0.25964 v 0 c -1.263295,0.49282 -2.7051,1.04633 -4.205462,1.60407"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1993",
    style: {
      fill: "#a771bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.155894,278.2612 c -1.80834,0 -3.617032,-0.69024 -4.997098,-2.07035 -0.08431,-0.0848 -0.17286,-0.18245 -0.265287,-0.29312 0.05785,-0.36406 0.08784,-0.73766 0.08784,-1.11799 0,-1.70712 -1.351491,-5.94959 -2.872671,-10.18328 4.683125,1.7974 10.348738,3.88162 15.000113,5.32483 0.40146,2.20518 -0.250121,4.56452 -1.955448,6.26956 -1.380067,1.38011 -3.188758,2.07035 -4.99745,2.07035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1995",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 57.108792,269.92129 c -4.651375,-1.44321 -10.316988,-3.52743 -15.000113,-5.32483 -0.26317,-0.73201 -0.531283,-1.46367 -0.798335,-2.18193 5.066948,1.94416 11.868502,4.39244 14.571485,4.63444 0.632883,0.87207 1.041755,1.85561 1.226963,2.87232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1997",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.893509,275.89773 c -1.740255,-2.0822 -4.818592,-8.62369 -7.02663,-13.58127 0.666398,-1.45521 1.294696,-2.86597 1.839383,-4.10775 v 0 0 0 0 0 0 0 c 0.0013,0.007 0.0028,0.0141 0.0042,0.0215 7.94e-4,0.004 0.0013,0.007 0.0021,0.0109 0.106892,0.57044 0.164749,1.15888 0.164749,1.76001 2.64e-4,0.61278 -0.05997,1.21215 -0.171099,1.79247 0.07585,0.0296 0.152049,0.0593 0.228955,0.0892 -0.03986,0.60536 -0.11783,1.20085 -0.228955,1.78435 0.762355,0.29704 1.566334,0.60854 2.402417,0.92921 1.52118,4.23369 2.872671,8.47616 2.872671,10.18329 0,0.38033 -0.02999,0.75392 -0.08784,1.11799"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1999",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.108679,264.59646 c -0.836083,-0.32067 -1.640062,-0.63218 -2.402417,-0.92922 0.111125,-0.58349 0.18909,-1.17898 0.228955,-1.78435 0.439912,0.1711 0.899935,0.34925 1.375127,0.53164 0.267052,0.71826 0.535165,1.44992 0.798335,2.18193 m -2.396067,-6.35529 c -7.93e-4,-0.004 -0.0013,-0.007 -0.0021,-0.0109 7.94e-4,0.004 0.0013,0.007 0.0021,0.0109 m -0.0063,-0.0325 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2001",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.270334,260.96849 c -0.03316,-0.0755 -0.06632,-0.15063 -0.09878,-0.22471 0.48895,-0.33267 0.954971,-0.71332 1.388182,-1.14689 0.433564,-0.43356 0.814564,-0.89958 1.146526,-1.38817 -0.505883,0.744 -1.08585,1.45344 -1.745895,2.11349 -0.224367,0.22472 -0.454731,0.43991 -0.690033,0.64628"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2003",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.866879,262.31646 c -0.207433,-0.46496 -0.406752,-0.91581 -0.596545,-1.34797 0.235302,-0.20637 0.465666,-0.42156 0.690033,-0.64628 0.660045,-0.66005 1.240012,-1.36949 1.745895,-2.11349 v 0 c -0.544687,1.24177 -1.172985,2.65253 -1.839383,4.10774"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2005",
    style: {
      fill: "#a771bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.277294,267.06838 c -0.119592,0 -0.251883,-0.007 -0.395465,-0.0194 -0.216604,-0.29845 -0.459317,-0.58385 -0.728485,-0.85302 -1.206852,-1.20685 -5.16255,-3.25084 -9.23149,-5.1689 4.582583,-2.04082 10.061575,-4.5727 14.371815,-6.84177 1.843262,1.27529 3.05082,3.40466 3.05082,5.81554 0,3.90384 -3.164062,7.06755 -7.067195,7.06755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2007",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 45.921854,261.02706 c -0.703792,-0.33162 -1.410758,-0.65934 -2.107493,-0.97861 4.957585,-2.20804 11.498439,-5.28637 13.580885,-7.02663 1.063977,0.16898 2.048933,0.57538 2.898423,1.16346 -4.31024,2.26907 -9.789232,4.80096 -14.371815,6.84178"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2009",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 55.881829,267.04897 c -2.702983,-0.242 -9.504537,-2.69028 -14.571485,-4.63444 -0.557742,-1.50036 -1.110898,-2.94252 -1.604082,-4.20582 0.006,0.004 0.01199,0.008 0.01799,0.0124 0.0032,0.002 0.0063,0.004 0.0095,0.006 0.479073,0.32808 0.935567,0.70273 1.361017,1.12818 0.433213,0.43286 0.814213,0.89924 1.146529,1.38819 0.07444,-0.0328 0.149225,-0.0656 0.224719,-0.0988 0.40005,0.45649 0.766233,0.93239 1.100315,1.4231 0.748593,-0.32843 1.53811,-0.67698 2.355495,-1.04104 4.06894,1.91805 8.024638,3.96204 9.23149,5.1689 0.269168,0.26917 0.511881,0.55456 0.728485,0.85301"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2011",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.566359,262.0681 c -0.334082,-0.49071 -0.700265,-0.96661 -1.100315,-1.4231 0.432152,-0.19015 0.883356,-0.38947 1.348317,-0.59655 0.696735,0.31927 1.403701,0.64699 2.107493,0.97861 -0.817385,0.36406 -1.606902,0.71261 -2.355495,1.04104 m -3.83258,-3.84069 c -0.0032,-0.002 -0.0064,-0.004 -0.0095,-0.006 0.0032,0.002 0.0063,0.004 0.0095,0.006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2013",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.935217,261.88289 c -0.07691,-0.03 -0.153106,-0.0596 -0.228955,-0.0892 0.111125,-0.58032 0.17145,-1.17969 0.171099,-1.79246 0,-0.60114 -0.05786,-1.18957 -0.164749,-1.76001 0.164397,0.87418 0.253649,1.77447 0.253649,2.69699 0,0.3175 -0.01058,0.63253 -0.03104,0.94473 M 39.7105,258.23028 c -0.0013,-0.007 -0.0028,-0.0145 -0.0042,-0.0215 v 0 c 0.0013,0.007 0.0028,0.0141 0.0042,0.0215"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2015",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.310344,262.41453 c -0.475192,-0.18239 -0.935215,-0.36054 -1.375127,-0.53164 0.02045,-0.3122 0.03104,-0.62723 0.03104,-0.94473 0,-0.92252 -0.08925,-1.82281 -0.253649,-2.69699 -7.93e-4,-0.004 -0.0013,-0.007 -0.0021,-0.0109 -0.0013,-0.007 -0.0028,-0.0145 -0.0042,-0.0215 v 0 c 0.493184,1.2633 1.04634,2.70545 1.604082,4.20582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2017",
    style: {
      fill: "#a771bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.912786,256.60463 c 1.943806,-5.06694 4.392083,-11.8692 4.634089,-14.57183 1.232604,-0.8943 2.688519,-1.34127 4.144434,-1.34127 1.808691,0 3.617383,0.69004 4.997095,2.0701 2.760133,2.76049 2.760133,7.23477 0,9.99455 -0.08467,0.0843 -0.18274,0.17321 -0.293158,0.26564 -0.364419,-0.0579 -0.737659,-0.0878 -1.117952,-0.0878 -2.002367,0 -7.491942,1.85914 -12.364508,3.67065"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2019",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.706262,258.20872 v 0 c 0.333024,-0.4886 0.713672,-0.95462 1.147234,-1.38819 0.433565,-0.43356 0.899231,-0.81456 1.388181,-1.14688 -0.219427,-0.49953 -0.451908,-1.02658 -0.695325,-1.57303 2.164644,-4.72617 4.731457,-9.92294 6.147152,-11.33899 0.269171,-0.26917 0.554921,-0.51223 0.853371,-0.72883 -0.242006,2.70263 -2.690283,9.50489 -4.634089,14.57183 -1.500717,0.55775 -2.942519,1.1109 -4.206524,1.60409"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2021",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.706262,258.20872 c 0.545042,-1.24214 1.17334,-2.65289 1.84009,-4.1081 0.243417,0.54645 0.475898,1.0735 0.695325,1.57303 -0.48895,0.33232 -0.954616,0.71332 -1.388181,1.14688 -0.433562,0.43357 -0.81421,0.89959 -1.147234,1.38819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2023",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.814361,260.04845 c -1.455209,-0.66675 -2.865967,-1.29505 -4.108099,-1.83973 v 0 c 0.581025,-0.11043 1.17969,-0.17075 1.792817,-0.17075 0.61313,0 1.212146,0.0603 1.792817,0.17075 0.198615,-0.50836 0.406754,-1.04599 0.62089,-1.60409 4.872566,-1.81151 10.362141,-3.67065 12.364508,-3.67065 0.380293,0 0.753533,0.03 1.117952,0.0878 -2.082446,1.74026 -8.6233,4.81859 -13.580885,7.02663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2025",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.291896,258.20872 c -0.580671,-0.11043 -1.179687,-0.17075 -1.792817,-0.17075 -0.613127,0 -1.211792,0.0603 -1.792817,0.17075 v 0 c 1.264005,-0.49319 2.705807,-1.04634 4.206524,-1.60409 -0.214136,0.5581 -0.422275,1.09573 -0.62089,1.60409"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2027",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.241325,260.74378 c -0.332316,-0.48895 -0.713316,-0.95533 -1.146529,-1.38819 -0.42545,-0.42545 -0.881944,-0.8001 -1.361017,-1.12818 0.734132,0.50201 1.434396,1.07562 2.08633,1.7272 0.224718,0.22437 0.439912,0.45473 0.645935,0.69039 -0.07549,0.0332 -0.150283,0.066 -0.224719,0.0988 m -2.517071,-2.52272 c -0.006,-0.004 -0.01199,-0.008 -0.01799,-0.0124 v 0 0 c 0.006,0.004 0.01199,0.008 0.01799,0.0124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2029",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.466044,260.645 c -0.206023,-0.23566 -0.421217,-0.46602 -0.645935,-0.69039 -0.651934,-0.65158 -1.352198,-1.22519 -2.08633,-1.7272 -0.0032,-0.002 -0.0064,-0.004 -0.0095,-0.006 -0.006,-0.004 -0.01199,-0.008 -0.01799,-0.0124 v 0 c 1.242132,0.54469 2.65289,1.17299 4.108099,1.83974 -0.464961,0.20708 -0.916165,0.4064 -1.348317,0.59655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2031",
    style: {
      fill: "#001dfc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 49.321221,257.95683 c 0,5.47652 -4.439002,9.91553 -9.915171,9.91553 -5.476171,0 -9.915525,-4.43901 -9.915525,-9.91553 0,-5.47582 4.439354,-9.91517 9.915525,-9.91517 5.476169,0 9.915171,4.43935 9.915171,9.91517"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower15);
export default __webpack_public_path__ + "static/media/flower-15.8f28c9d42266820d812b2f0989db06ee.svg";
export { ForwardRef as ReactComponent };